const Services = () => {
  const services = [
    {
      icon: '✈️',
      title: 'Air Freight',
      description: 'Rapid, dependable air cargo handling for priority shipments that demand speed and accuracy.',
      features: ['Priority & express air cargo', 'Door-to-door delivery', 'Temperature-controlled logistics', 'Safe handling of sensitive & hazardous goods']
    },
    {
      icon: '🚢',
      title: 'Ocean Freight',
      description: 'Flexible, scalable, and economical shipping solutions for global trade and bulk cargo.',
      features: ['FCL & LCL shipment options', 'Project cargo & oversized freight', 'Port-to-port or door-to-door shipping', 'Real-time container tracking']
    },
    {
      icon: '📋',
      title: 'Customs Brokerage',
      description: 'Expert guidance and clearance services to ensure your shipments pass through customs without delays.',
      features: ['Import/export documentation', 'Duty savings & optimization', 'Trade regulation advisory', 'Compliance monitoring']
    },
    {
      icon: '🏭',
      title: 'Warehousing',
      description: 'Secure, well-managed storage facilities with real-time inventory monitoring and optimized distribution.',
      features: ['Temperature-controlled storage', 'Stock & inventory visibility tools', 'Pick & pack operations', 'Cross-docking solutions']
    },
    {
      icon: '🚚',
      title: 'Ground Transportation',
      description: 'Reliable and efficient domestic & cross-border ground logistics to keep your supply chain moving.',
      features: ['FTL & LTL trucking', 'Rail & intermodal movement', 'Secure long-haul solutions', 'Last-mile distribution']
    },
    {
      icon: '📊',
      title: 'Supply Chain Management',
      description: 'Holistic supply chain optimization that enhances performance, reduces costs, and minimizes risks.',
      features: ['End-to-end supply chain consulting', 'Vendor & procurement management', 'Risk assessment & forecasting', 'Digital performance analytics']
    }
  ]

  return (
    <section className="section-container bg-black" id="services">
      <div className="text-center mb-12">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
          Comprehensive Logistics Solutions
        </h2>
        <p className="text-xl text-gray-400 max-w-3xl mx-auto">
          Tailored freight and supply chain services designed to meet your business requirements.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        {services.map((service, index) => (
          <div
            key={index}
            className="card group hover:scale-105 transition-all duration-200"
          >
            <div className="text-5xl mb-4">{service.icon}</div>
            <h3 className="text-xl font-bold text-white mb-3">
              {service.title}
            </h3>
            <p className="text-gray-400 mb-4">
              {service.description}
            </p>
            <ul className="space-y-2">
              {service.features.map((feature, idx) => (
                <li key={idx} className="flex items-start text-sm text-gray-400">
                  <svg className="w-5 h-5 text-white mr-2 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                  </svg>
                  {feature}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </section>
  )
}

export default Services
